import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import sam1 from '../../assets/sam1.webp';
import sam2 from '../../assets/sam2.webp';
import sam10 from '../../assets/sam10.webp';
import styles from './HeroCreativitySection.module.css';

const imageUrls = [
  sam2,
  sam1,
  sam10,
];

const HeroCreativitySection = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isPreloaded, setIsPreloaded] = useState(false);

  useEffect(() => {
    const preloadImages = () =>
      Promise.all(
        imageUrls.map((src) => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = resolve;
          });
        })
      );

    preloadImages().then(() => {
      setIsPreloaded(true);
    });
  }, []);

  useEffect(() => {
    let interval;
    if (isPreloaded) {
      interval = setInterval(() => {
        setCurrentImage((prev) => (prev + 1) % imageUrls.length);
      }, 500);
    }
    return () => clearInterval(interval);
  }, [isPreloaded]);

  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        <div className={styles.imageContainer}>
          <AnimatePresence mode="wait">
            <motion.img
              key={imageUrls[currentImage]}
              src={imageUrls[currentImage]}
              alt="Creative sequence"
              className={styles.image}
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 1 }}
              transition={{ duration: 0 }}
            />
          </AnimatePresence>
        </div>

        <div className={styles.textContainer}>
          <h2 className={styles.heading}>
            Welcome<br />
            to my<br />
            Musical World <span className={styles.dot}>◓</span>
          </h2>
          <NavLink to="/about" className={styles.button}>Explore With Me</NavLink>
        </div>
      </div>
    </section>
  );
};

export default HeroCreativitySection;
